import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationService } from 'src/app/_services/navigation.service';
import { ToastrService } from 'ngx-toastr';
import { WebsiteService } from 'src/app/_services/website.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LoadScriptService } from 'src/app/_services/load-script.service';
import { RecaptchaService } from 'src/app/_services/recaptcha.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-book-ademo-form',
  templateUrl: './book-ademo-form.component.html',
  styleUrls: ['./book-ademo-form.component.scss']
})
export class BookADemoFormComponent implements OnInit {
  @Input() subtitle: string | null = null;
  @Input() emailLabel: string = 'University Email*';
    contactForm: FormGroup;
    formSection: boolean = true;
    thankSection: boolean = false;
    country: string;
    isSubmitting: boolean = false;
    tabsData: any;
    constructor(
      private toastr: ToastrService,
      private networkCall: WebsiteService,
      private fb: FormBuilder,
      @Inject(PLATFORM_ID) private platformId: Object,
      public loadScript: LoadScriptService,
      private router: Router,
      public navigationService: NavigationService,
      private recaptcha: RecaptchaService,
    ) {
      this.contactForm = fb.group({
        'contactFormName': ['', Validators.required],
        'contactFormEmail': ['', Validators.compose([Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)])],
        'contactphoneNo': ['', Validators.required],
        'DesignationTypes': ['', Validators.required],
        'website': ['']
      });
     }

  ngOnInit(): void {
  }

  
  sendContactUsForm() {
    if (this.contactForm.value.website) {
      console.warn('Spam detected');
      return;
    }
    if (this.contactForm.invalid) {
      this.validateAllFormFields(this.contactForm);
      return;
    }
  
    this.isSubmitting = true;
  
    if (!localStorage.getItem("country-trinka")) {
      this.loadGeoAPIScript();
    }
    this.country = localStorage.getItem("country-trinka") || "en";
  
    this.recaptcha.getToken('contact_form').then(token => {
  
      const name = this.contactForm.value.contactFormName;
      const designation = this.contactForm.value.DesignationTypes;
      const phone = this.contactForm.value.contactphoneNo;
      const email = this.contactForm.value.contactFormEmail;
      const source = this.router.url || 'N/A';

      const comments = `URL - ${source}`;
  
      const query = `${name}||${designation}||${phone}`;
  
      const payload = {
        email,
        query,
        source,
        recaptchaToken: token
      };
  
      console.log('✅ reCAPTCHA token:', token);
  
      this.networkCall.postContactUs(email, query, source).subscribe({
        next: () => {
          this.toastr.success("Thanks! We will contact you shortly.");
          this.formSection = false;
          this.thankSection = true;
          this.contactForm.reset();
        },
        error: () => {
          this.toastr.warning("Something went wrong!");
        }
      }).add(() => {
        this.isSubmitting = false;
      });
  
    }).catch(err => {
      console.error('reCAPTCHA error:', err);
      this.isSubmitting = false;
    });
  }

  
  

  loadGeoAPIScript() {
    if (isPlatformBrowser(this.platformId)) {
      var scriptName = "geoIP"
      this.loadScript.loadScript(scriptName, '//geoip-js.com/js/apis/geoip2/v2.1/geoip2.js')
        .then(() => {
          console.log(`${scriptName} loaded successfully`);
          var onSuccess = function (location) {
            localStorage.setItem("country-trinka", location['country']['iso_code'])
          };

          var onError = function (error) {
            localStorage.setItem("country-trinka", "IN")
          };
          try {
            //@ts-ignore
            geoip2.city(onSuccess, onError);
          } catch (error) {
            console.log(error)
          }
        })
        .catch(() => {
          console.error(`Failed to load ${scriptName}`);
        });
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }

}
